import assetPath from '/app/xinglets/lebenslauf/pages/startpage/src/assets/templates-preview-1x.png';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')